
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'number-input',
  props: {
    url: String,
    label: { type: String, required: true },
    modelValue: String,
  },
  emits: ['update:modelValue'],
  computed: {
    getId(): string {
      return this.label.replaceAll(' ', '-').toLowerCase();
    },
  },
});
